import type {
    MonitoringProjectGroupRepository,
} from '~/src/shared/api/repositories/monitoring/project-group/model'
import type { CreateProjectGroupDto, ProjectGroupDto } from '~/src/shared/types/generated'
import { endpoints } from './endpoints'

export function monitoringProjectGroupRepository(): MonitoringProjectGroupRepository {
    const { $ofetch } = useNuxtApp()

    const deleteProjectGroup = (id: number): Promise<boolean> =>
        $ofetch(endpoints.projectGroupById(id), { method: 'DELETE' })

    const getProjectGroupById = (id: number): Promise<ProjectGroupDto> =>
        $ofetch(endpoints.projectGroupById(id), { method: 'GET' })

    const getAllProjectGroups = (): Promise<ProjectGroupDto[]> =>
        $ofetch(endpoints.projectGroup, { method: 'GET' })

    const createProjectGroup = (data: CreateProjectGroupDto): Promise<ProjectGroupDto> =>
        $ofetch(endpoints.projectGroup, { method: 'POST', body: data })

    const editProjectGroup = (id: number): Promise<ProjectGroupDto> =>
        $ofetch(endpoints.projectGroupById(id), { method: 'PUT' })

    return {
        deleteProjectGroup,
        getProjectGroupById,
        getAllProjectGroups,
        createProjectGroup,
        editProjectGroup
    }
}
